<template>
  <div class="cbg-auth__save" :class="context.errorMessage ? 'cbg-auth__save_warning': ''">
    <Svg class-name="cbg-auth__save-ico" :icon-id="statusIco" />
    <span class="cbg-auth__save-message">{{statusMessage}}</span>
  </div>
</template>

<script>
import Svg from "@/components/global/Svg.vue";
import {ContextStateSymbol} from "@/components/global/Context.vue";

export default {
  name: 'SaveMessage',
  components: {Svg},
  inject: {
    context: { from: ContextStateSymbol, default: {} },
  },
  computed: {
    statusMessage() {
      return this.context.errorMessage ?? 'The changes are saved';
    },
    statusIco() {
      return this.context.errorMessage ? '#warning' : '#success';
    },
  },
}
</script>